module.exports = __webpack_public_path__ + "static/media/2.97024dfd.png";